import {_} from "backboneAdapter";
import Handlebars from 'handlebars';
import ServiceGenericView from 'js/views/service.generic.view';
import Template from 'js/templates/service.hbs';
import ContentTemplate from 'js/templates/content.tile.selected.hbs';
import UserServiceFilesTemplate from 'js/templates/service.theme.userfiles.hbs';
import i18n from 'l10n';
import ServiceReportView from 'js/views/service.report.view';
import ServiceMapLocationView from 'js/views/service.mapLocation.view';
import {on, template} from "../adapters/backbone-decorators";

@template(Template, {preventIndent: true})
class VoucherView extends ServiceGenericView {
    constructor(isPostPaid, model) {
        super(isPostPaid, model);
        this.ContentTemplate = ContentTemplate;
        this.userServiceFilesTemplate = Handlebars.compile(UserServiceFilesTemplate);
        this.draggingCustomBgImage = false;
        this.invalidFieldName = null;

        this.on("selected:voucherDefaultContent", () => {
            this.selectDefaultLogo();
            $.Dialog.close();
        }, this);

        this.render();
    }

    get serviceType() {
        return "Voucher";
    }

    render() {
        if (this.isConfigured()) {
            var cfg = this.model.get('voucherConfig');
            cfg.redemptionMessages = cfg.redemptionMessages.slice(0, cfg.redemptionMessageCount);
        }

        super.render();
        this.validateCondition(this);

        if (!this.isConfigured()) {
            this.checkMessagesCount();
        } else {
            this.serviceReport = new ServiceReportView({
                serviceId: this.model.get('campaignId'),
                title: this.model.get('title'),
                serviceType: "Voucher",
                description: this.model.get("description")
            });
        }

        var $messages = $("#messages-configuration .edit");
        if (parseInt($($messages[0]).text()) === 0) {
            $($messages[0]).text(1);
        }

        this.file_content_accordion = this.$("#select-file-content > .accordion");
        this.file_content_accordion.accordion({
            action: frame => {
                if (this.model.get("campaignId") === 0) {
                    const isCollapsed = frame.find(".heading").hasClass("collapsed");
                    const prompt = isCollapsed ? i18n.t("message.taptoselect") : i18n.t("message.selectcontenttitle");
                    frame.find(".accordion-prompt").text(prompt)
                }
            }
        });

        if (this.model.get("voucherPageConfig").get("logoContentId")) {
            this.showContent();
        } else {
            this.$("#logo").show();
            const src = "/CampaignCloud/resources/images/defaultPassLogo2.png";
            this.$(" #logo").attr({src});
            this.$(".preview-container-div .preview #logo").attr({src});
            this.$(".preview-container-div .preview #logo").show();
        }

        this.setServiceStatus();

        $("#composeMessage").unbind("click").on("click", this.toggleMessageButtonsVisibility);

        if (this.isEventTicket()) {
            //change width of fields on Event Ticket pass preview, so bigTexts will use the whole line to calculate font-sizes, in case of other empty fields
            this.setFieldsStylesOnPassPreview(null, null);
        } else {
            var mapMarkers = this.model.get("voucherPageConfig").get("mapLocations");
            //init map locations view, only on "eventTicket" type vouchers
            this.serviceMapLocationView = new ServiceMapLocationView({markers: mapMarkers, ccView: this});
        }
        this.doActionsAndCalculateFontSizes(null);

        return this;
    }

    toggleMessageButtonsVisibility() {
        var e = $("#sendmessagefloatingbutton");
        if (e.css("display") === 'block') {
            e.css("display", "none");
        } else {
            e.css("display", "block");
        }
    }

    toggleVisibilityOfElement(element, display) {
        if (display === "toggle") {
            $(element).toggle();
        } else { //e.g. "display: none, block
            $(element).css("display", display);
        }
    }

    toggleShadowOfElement(element, shadow) {
        $(element).css("box-shadow", shadow);
    }

    toggleBorderColorOfElement(element, border) {
        var parent = element.parent();
        var questionIndex = parent.data("cid");
        var elemToggleBorder = $(`.surveyquestionborder${questionIndex}`);
        $(elemToggleBorder).css("outline-color", border);
    }

    rewireEvents() {
        this.$("#componentsSurface").find('.edit').each((i, e) => {
            this.makeEditable(i, e, this);
        });
//			self.loadContentSelectors();
    }

    updateCallback(attributeName, value, outcome, e, settings) {
        super.updateCallback(attributeName, value, outcome, e, settings);

        if ($(e).hasClass("voucherConfig.redemptionMessages")) {
            this.model.fetch({
                success: () => {
                    this.checkMessagesCount();
                }
            });
        }

        return this;
    }

    @on('click #closeMap')
    closeMapDiv() {
        $("#mapContainer").hide();
    }

    @on('click #addNewPassLocation')
    addNewPassLocation() {
        var mapLocations = this.model.get("voucherPageConfig").get("mapLocations");
        if (mapLocations && mapLocations.length === 10) {
            $.Notify.show(i18n.t("voucher.noMoreMapLocationsAvailable"));
            return;
        }
        $('#updateMarker').hide();
        $('#saveNewMarker').show();
        $("#mapContainer").show();
        this.serviceMapLocationView.renderMap();
    }

    @on('click #showPassPreviewBackPage')
    @on('click #showPassPreviewFrontPage')
    togglePassPreviewBackPage(e) {
        $(".flip-container").toggleClass("flip");
        this.doActionsAndCalculateFontSizes(null);
    }

    doActionsAndCalculateFontSizes(options) {
        var $passFrontPageThumbnail = $("#passFrontPageThumbnail");
        $passFrontPageThumbnail.removeClass("scaled");
        this.calculateBigTexts(options);
        //remove `scaled` class of the thumbnail div, in order for `calculateBigTexts`
        // to be able to calculate font-sizes appropriately
        if ($(".flip-container").hasClass("flip")) {
            //let `calculateBigTexts` calculate font sizes and then scale
            $passFrontPageThumbnail.addClass("scaled");
        }
    }

    @on("click #messages-configuration .remove-rule")
    removeRule() {
        this.$(".redemptionMessages:visible").last().find("[type=reset]").click()
        this.messageRule(-1);
        var len = this.model.get("voucherConfig").redemptionMessageCount;
        var count = 0;

        var tempVoucherConfig = this.model.get("voucherConfig");
        tempVoucherConfig.redemptionMessages[len - 1].count = count;
        this.model.set("voucherConfig", tempVoucherConfig);
    }

    @on("click #messages-configuration .add-rule")
    addRule() {
        var len = this.model.get("voucherConfig").redemptionMessageCount;
        var count = parseInt(this.model.get("voucherConfig").redemptionMessages[len - 1].count);

        var countToAdd = count >= len ? count : len;

        var $messages = $("#messages-configuration .edit");
        $($messages[2 * len]).text(countToAdd + 1);
        var tempVoucherConfig = this.model.get("voucherConfig");
        tempVoucherConfig.redemptionMessages[len - 1].count = count;
        this.model.set("voucherConfig", tempVoucherConfig);
        this.messageRule(+1);
    }

    checkMessagesCount() {
        var N = 20;
        var min = 1;
        var messagesCount = this.model.get("voucherConfig").redemptionMessageCount;
        var addBtn = this.$("#messages-configuration .add-rule");
        var removeBtn = this.$("#messages-configuration .remove-rule");
        var max = 1;

        if (!(messagesCount >= min && messagesCount <= N)) {
            messagesCount = min;
        }

        this.$("#messages-configuration .redemptionMessages.row").each((index, elem) => {
            if (index <= (messagesCount - min)) {
                if (this.model.get("voucherConfig").redemptionMessages[index].count < max) {
                    var attr = `voucherConfig.redemptionMessages[${index}].count`;
                    var value = max;

                    this.model.saveAttribute(attr, value, (attributeName, value1, outcome) => {
                        if ("OK" !== outcome) {
                            this.render();
                        } else {
                            $($(elem).children(".edit")[0]).text(value);
                            const tempVoucherConfig = this.model.get("voucherConfig");
                            tempVoucherConfig.redemptionMessages[index].count = value;
                            this.model.set("voucherConfig", tempVoucherConfig);
                        }
                    });
                } else {
                    max = this.model.get("voucherConfig").redemptionMessages[index].count;
                }
                max++;

                $(elem).show();
            } else {
                $(elem).hide();
            }
        });

        if (messagesCount > min && messagesCount < N) {
            addBtn.show();
            removeBtn.show();
        } else if (messagesCount <= min) {
            addBtn.show();
            removeBtn.hide();
        } else if (messagesCount >= N) {
            addBtn.hide();
            removeBtn.show();
        }

    }

    async messageRule(action) {
        const maxRules = 20;
        const min = 1;
        const setMsgCount = this.model.get("voucherConfig").redemptionMessageCount;

        const messagesCount = setMsgCount >= min && setMsgCount <= maxRules ? setMsgCount : min;

        if ((messagesCount + action) >= min && (messagesCount + action) <= maxRules) {
            const value = messagesCount + action;

            try {
                const {outcome} = await this.model.saveAttribute("voucherConfig.redemptionMessageCount", value, _.noop);

                $.Notify.show(i18n.t("generic.attributechanged", {
                    attributeName: "voucherConfig.redemptionMessageCount",
                    value,
                    outcome: i18n.t(`generic.=${outcome}`)
                }));

                if ("OK" !== outcome) {
                    this.render();
                } else {
                    if (action === -1) {
                        const {outcome: mo} = await this.model.saveAttribute(`voucherConfig.redemptionMessages[${value}].message`, null, _.noop);
                        const {outcome: co} = await this.model.saveAttribute(`voucherConfig.redemptionMessages[${value}].count`, 0, _.noop);

                        if (mo === "OK" && co === "OK") {
                            var currentRowCount = this.$(`.rulecnt${value}`);
                            var previousRowCount = this.$(`.rulecnt${value - 1}`);
                            currentRowCount.text(1 + Number.parseInt(previousRowCount.text() || 0));
                            var currentRowMessage = this.$(`.rulemsg${value}`);
                            currentRowMessage.html(`<placeholder>${currentRowMessage.attr('title')}</placeholder>`);
                        }
                    }
                    this.checkMessagesCount();
                }
            } catch (e) {
                console.error("Couldn't remove voucher rule.");
            }
        }
    }

    pagetitleSubmit(input) {
        $('[id="pagetitle"]').text(input.val());
        $('[id="passPreviewPageTitle"]').text(input.val());
        this.doActionsAndCalculateFontSizes(null);
    }

    pagetextSubmit(input) {
        $('[id="pagetext"]').text(input.val());
        $('[id="passPreviewPageText"]').text(input.val());

        if (this.isEventTicket()) {
            //change width of fields on Event Ticket pass preview, so bigTexts will use the whole line to calculate font-sizes, in case of other empty fields
            this.setFieldsStylesOnPassPreview(input.val(), "pageText");
        }
        this.doActionsAndCalculateFontSizes(null);
    }

    footerSubmit(input) {
        $('[id="footer"]').text(input.val());
    }

    subFooterSubmit(input) {
        $('[id="subFooter"]').text(input.val());
        $('[id="passPreviewSubFooter"]').text(input.val());

        if (this.isEventTicket()) {
            //change width of fields on Event Ticket pass preview, so bigTexts will use the whole line to calculate font-sizes, in case of other empty fields
            this.setFieldsStylesOnPassPreview(input.val(), "subFooterText");
        }
        this.doActionsAndCalculateFontSizes(null);
    }

    suggestionspagetexttitleSubmit(input) {
        var index = $(input).parent().parent().attr("data-index");
        $(`#surveypreviesuggestions${index}`).text(input.val());
    }

    suggestionspagetexttextSubmit(input) {
        var index = $(input).parent().parent().attr("data-index");
        $(`#surveypreviesuggestionsfooter${index}`).text(input.val());
    }

    additionalInfoSubmit(input) {
        $('[id="additionalInfo"]').html(input.val());
        var $passPreviewAdditionalInfo = $("#passPreviewAdditionalInfo");
        $passPreviewAdditionalInfo.html(input.val());
        if (input.val().trim().length > 0) {
            $passPreviewAdditionalInfo.parent().show();
        } else {
            $passPreviewAdditionalInfo.parent().hide();
        }
    }

    eventStartDateSubmit(input) {
        var valueToSet = input.val();

        if (valueToSet) {
            var inputToDate = valueToSet;
            var currentDate = Date.now();

            this.setValuesForDateField(inputToDate, "#eventStartDate", "#passPreviewStartDate");
        } else {
            $('[id="passPreviewStartDate"]').hide();
            $("#eventStartDate").parent().hide(); //mobile preview
        }

        //change width of fields on Event Ticket pass preview, so bigTexts will use the whole line to calculate font-sizes, in case of other empty fields
        this.setFieldsStylesOnPassPreview(input.val(), "eventStartDate");
        this.doActionsAndCalculateFontSizes(null);
    }

    eventEndDateSubmit(input) {
        var valueToSet = input.val();

        if (valueToSet) {
            var inputToDate = valueToSet;
            var currentDate = Date.now();

            this.setValuesForDateField(inputToDate, "#eventEndDate", "#passPreviewEndDate");
        } else {
            $('[id="passPreviewEndDate"]').hide();
            $("#eventEndDate").parent().hide(); //mobile preview
        }

        //change width of fields on Event Ticket pass preview, so bigTexts will use the whole line to calculate font-sizes, in case of other empty fields
        this.setFieldsStylesOnPassPreview(input.val(), "eventEndDate");
        this.doActionsAndCalculateFontSizes(null);
    }

    setValuesForDateField(date, elementId, passElementId) {
        var $passFrontPageThumbnail = $("#passFrontPageThumbnail");
        $($passFrontPageThumbnail.find(passElementId)).text(Handlebars.helpers.timestampWithMonthText(date, "L HH:mm"));
        var $passPreviewFrontPage = $("#passPreviewFrontPage");
        $($passPreviewFrontPage.find(passElementId)).text(Handlebars.helpers.timestampWithMonthText(date, "L HH:mm"));
        $($passFrontPageThumbnail.find(passElementId)).parent().show();
        $($passPreviewFrontPage.find(passElementId)).parent().show();

        $(elementId).text(Handlebars.helpers.timestampWithMonthText(date, "L HH:mm"));
        $(elementId).parent().css("display", "inline-block"); //mobile preview
        $(elementId + "Config").text(Handlebars.helpers.timestampWithMonthText(date, "L HH:mm")); //Configuration field

    }

    setFieldsStylesOnPassPreview(val, field) {
        //this function should only be called when the Voucher Pass type, is `eventTicket`
        var hasEventStartDate = false;
        var hasEventEndDate = false;
        var hasAddress = false;

        //if field is not `null`, then the function was called inside a `field.onSubmit`, so the model's Value is not set yet
        switch (field) {
            case "subFooterText":
                hasEventStartDate = this.model.get("voucherPageConfig").get("eventStartDate");
                hasEventEndDate = this.model.get("voucherPageConfig").get("eventEndDate");
                hasAddress = val && val.trim().length > 0;
                break;
            case "eventStartDate":
                hasEventStartDate = val;
                hasEventEndDate = this.model.get("voucherPageConfig").get("eventEndDate");
                hasAddress = this.model.get("voucherPageConfig").get("subFooterText") &&
                    this.model.get("voucherPageConfig").get("subFooterText").trim().length > 0;
                break;
            case "eventEndDate":
                hasEventStartDate = this.model.get("voucherPageConfig").get("eventStartDate");
                hasEventEndDate = val;
                hasAddress = this.model.get("voucherPageConfig").get("subFooterText") &&
                    this.model.get("voucherPageConfig").get("subFooterText").trim().length > 0;
                break;
            default:
                hasEventStartDate = this.model.get("voucherPageConfig").get("eventStartDate");
                hasEventEndDate = this.model.get("voucherPageConfig").get("eventEndDate");
                hasAddress = this.model.get("voucherPageConfig").get("subFooterText") &&
                    this.model.get("voucherPageConfig").get("subFooterText").trim().length > 0;
        }

        var initialPassPreviewFieldWidth = 150; //in pixels
        if (hasEventEndDate || hasEventStartDate) {
            $('[id="secondaryFields"]').show(); //event dates field
            // show NON-NULL fields and hide NULL ones, but change the row's width (for fields in the same row),
            // so the `dynamicFontSize` will use the whole row to do its calculations
            if (!hasEventEndDate) {
                $('[id="passPreviewEndDateContainer"]').hide(); //hide endDate field on pass preview, if its value is NULL
                $("#nullifyEventEndDateButton").hide();

                $("#nullifyEventStartDateButton").show();
                $("#passPreviewStartDateContainer").css({"width": (2 * initialPassPreviewFieldWidth + "px")}); //double the width since the other field is `null`

                $('[id="passPreviewStartDateContainer"]').show();

                $('.datesDashSeparator').hide();
            } else if (!hasEventStartDate) {
                $('[id="passPreviewStartDateContainer"]').hide();
                $("#nullifyEventStartDateButton").hide();
                $("#nullifyEventEndDateButton").show();
                $("#passPreviewEndDateContainer").css({"width": (2 * initialPassPreviewFieldWidth + "px")}); //double the width since the other field is `null`

                $('[id="passPreviewEndDateContainer"]').show();

                $('.datesDashSeparator').hide();
            } else {
                $("#nullifyEventStartDateButton").show();
                $("#nullifyEventEndDateButton").show();
                $('[id="passPreviewStartDateContainer"]').css({"width": (initialPassPreviewFieldWidth + "px")});
                $('[id="passPreviewEndDateContainer"]').css({"width": (initialPassPreviewFieldWidth + "px")});


                $('[id="passPreviewStartDateContainer"]').show();
                $('[id="passPreviewEndDateContainer"]').show();

                $('.datesDashSeparator').css("display", "inline-block"); //dash between the two dates
            }
        } else {
            $('[id="secondaryFields"]').hide();
            $('.datesDashSeparator').hide();
        }
        if (hasAddress) {
            $('[id="auxiliaryFields"]').show(); //Address field
        } else {
            $('[id="auxiliaryFields"]').hide();
        }
    }

    isEventTicket() {
        return ["showTicket", "eventAdmission"].indexOf(this.model.get("description")) > -1;
    }

    changeContent(existingContentId) {
        var e = this.$("#select-file-content");
        e.find(".accordion .heading").addClass("collapsed");
        e.find(".accordion .selected").removeClass("selected");

        var attr = "voucherPageConfig.logoContentId";
        this.model.storeAttribute(attr, existingContentId);
        this.showContent();
    }

    getContent(self, callback) {
        $.ajaxDefaultQ({
            url: `/CampaignCloud/Content/LoadFileContent/${self.model.get("voucherPageConfig").get('logoContentId')}`,
            type: 'GET',
            contentType: "application/json",
            dataType: 'json'
        }).done(function (data) {
            if (data) {
                self.targetingSize = data;
                callback(self, data);
            }
        }).fail(function (data) {
            console.error(data);
        });
    }

    showContent() {
        this.getContent(this, (self, data) => {
            self.$(".selected-file-content-tile").text("");

            const contentOrDefaultLogoTemplate = "<div class=\"grid ntm nbm\"><div class=\"row nbm ntm\"></div></div>";
            self.$(".selected-file-content-tile").append(contentOrDefaultLogoTemplate);

            self.$(" #logo").show();
            self.$('[id="logo"]').attr({"src": `/CampaignCloud/Content/LoadFileContentBytes/${data.contentId}`});
        });
    }

    selectDefaultLogo() {
        var attr = "voucherPageConfig.logoContentId";
        var value = null;
        this.model.storeAttribute(attr, value);
        this.render();
        var e = this.$("#select-file-content");
        e.find(".accordion .heading").addClass("collapsed");
        e.find(".accordion .selected").removeClass("selected");
        e.find(".accordion .content").hide();
        this.$(".selected-file-content-tile").text();
        this.$(".preview-container-div .preview #logo").show();

    }

    isValidRedemptionRulesNumbering() {
        var array = this.model.get("voucherConfig").redemptionMessages;

        return _.reduce(array, function (memo, num) {
            if (memo === false)
                return false;
            else if (memo > num)
                return false;
            else
                return num;
        });
    }

    validateCondition(self) {
        var isValid = self.isValidRedemptionRulesNumbering() && self.validateEventDates();
        return self.toggleExecuteButtonCallback(isValid, self);
    }

    setEventDateToNull(attribute) {
        //in fact we reset the form (editing) and nullify the model's value
        var self = this;
        var eventDateName = attribute;
        var $2 = $(`#${eventDateName}Config`);
        if ($2.find("form").length >= 1) {
            $2.find('[type="reset"]').trigger("click");
        }

        var attributeName = `voucherPageConfig.${eventDateName}`;
        var voucherPageConfig = self.model.get("voucherPageConfig");

        if (eventDateName === "eventEndDate") {
            voucherPageConfig.eventEndDate = null;
        } else if (eventDateName === "eventStartDate") {
            voucherPageConfig.eventStartDate = null;
        } else return;

        self.model.set("voucherPageConfig", voucherPageConfig);
        self.model.set(attributeName, null);
        if (eventDateName === "eventEndDate") {
            self.$('#nullifyEventEndDateButton').hide();
            self.$("#eventEndDate").text(""); //empty the element's text and hide its container

            self.$("#eventEndDate").parent().hide();
            var $eventEndDateConfig = $("#eventEndDateConfig");

            // avoid html injection
            var $placeholder = $("<placeholder/>");
            $placeholder.text(`${$eventEndDateConfig.data("placeholder")}`);

            $eventEndDateConfig.empty();
            $eventEndDateConfig.append($placeholder);

            $('[id="passPreviewEndDate"]').text("");
            $('[id="passPreviewEndDateContainer"]').hide();
        } else if (eventDateName === "eventStartDate") {
            self.$('#nullifyEventStartDateButton').hide();
            self.$("#eventStartDate").text(""); //empty the element's text and hide its container
            self.$("#eventStartDate").parent().hide();
            var $eventStartDateConfig = $("#eventStartDateConfig");

            // avoid html injection
            var $placeholder = $("<placeholder/>");
            $placeholder.text(`${$eventEndDateConfig.data("placeholder")}`);

            $eventEndDateConfig.empty();
            $eventEndDateConfig.append($placeholder);

            $('[id="passPreviewStartDate"]').text("");
            $('[id="passPreviewStartDateContainer"]').hide();
        }
        self.setFieldsStylesOnPassPreview(null, null);
    }

    validateEventDates() {
        var self = this;
        var voucherPassType = Handlebars.helpers.getVoucherTypeByDescription(self.model.get("description"), null);

        if (voucherPassType === "coupon") {
            return true;
        } else if (voucherPassType === "eventTicket") {
            var eventStartDate = self.model.get("voucherPageConfig").get("eventStartDate");
            var eventEndDate = self.model.get("voucherPageConfig").get("eventEndDate");

            if (!eventStartDate && !eventEndDate) {
                return true;
            } //if both dates are null, then there is nothing to check
            //check for type "string" since they are saved in this format in mongo: `YYYY/mm/dd H:m`
            if (typeof eventStartDate === "string") {
                eventStartDate = new Date(eventStartDate).getTime();
            }
            if (typeof eventEndDate === "string") {
                eventEndDate = new Date(eventEndDate).getTime();
            }

            let isValid, currentDate = Date.now();
            var eventStartDateAfterNow = !eventStartDate ? true : eventStartDate > currentDate;
            var eventEndDateAfterNow = !eventEndDate ? true : eventEndDate > currentDate;
            var eventEndDateAfterStartDate = (eventStartDate && eventEndDate) ? eventEndDate > eventStartDate : true;

            isValid = eventStartDateAfterNow && eventEndDateAfterNow && eventEndDateAfterStartDate;
            if (!isValid) {
                if (!eventStartDateAfterNow) {
                    self.invalidFieldName = "voucher.noPreviousDateThanNow"; //variable `self.invalidFieldName` initialized in `service.generic.view`
                } else if (!eventEndDateAfterNow) {
                    self.invalidFieldName = "voucher.noEndDateBeforeNow";
                } else if (!eventEndDateAfterStartDate) {
                    self.invalidFieldName = "voucher.noStartDateAfterEndDate";
                } else {
                    self.invalidFieldName = "voucher.errorOccurred";
                }
            }

            return isValid;
        }
    }

    async execute() {
        var pristineRulesConfig = this.model.get("voucherConfig").redemptionMessageCount === 1
            && this.model.get("voucherConfig").redemptionMessages[0].message === undefined
            && this.model.get("voucherConfig").redemptionMessages[0].count === 1;
        var boxTitle = i18n.t("voucher.confirmstartvouchertitle");
        var boxText = i18n.t("voucher.confirmstartvouchertext");
        var alertText = i18n.t("voucher.voucherstartsuccessfully");
        if (this.model.get("description") === "points") {
            boxTitle = i18n.t("voucher.confirmstartloyaltycardtitle");
            boxText = i18n.t("voucher.confirmstartloyaltycardtext");
            alertText = i18n.t("voucher.loyaltycardstartsuccessfully");
        }
        var extraText = pristineRulesConfig ? ` ${i18n.t("voucher.confirmstartvouchertextnorules")}` : "";
        var finalBoxText = boxText + extraText;

        await super.execute(boxTitle, finalBoxText, alertText);
    }

    findOrderOfRedemption(contacts, countRedems) {
        contacts.forEach(function (c) {
            c.orderOfRedemption = countRedems[c.subscriptionId];
            countRedems[c.subscriptionId]--;
        });
        return contacts;

    }

    countRedemptionsPerSubscriber(ids) {
        var count = {};
        ids.forEach(function (i) {
            count[i] = (count[i] || 0) + 1;
        });
        return count;
    }

    sumRedemptionsAndcountOfContacts(redems) {
        var sumRedemsAndCountContacts = {};
        var sumRedems = 0;
        var countContacts = 0;
        for (var i in redems) {
            sumRedems = sumRedems + redems[i];
            countContacts++;
        }
        sumRedemsAndCountContacts.sumRedems = sumRedems;
        sumRedemsAndCountContacts.countContacts = countContacts;
        return sumRedemsAndCountContacts;
    }

    checkRuleCount(e) {
        // check Voucher Rule numbering
        var valueToAdd = parseInt(e.prop("value"));
        if (valueToAdd <= 0) {
            return false;
        }

        var totalRulesCount = this.model.get("voucherConfig").redemptionMessageCount;

        if (totalRulesCount === 1) {
            return;
        }

        //get current rule index from parent.parent Div
        var tempVal = ((e.parent().parent())[0].attributes)[0].value;
        tempVal = tempVal.substr(tempVal.indexOf("rulecnt") + 7);
        tempVal = tempVal.substr(0, tempVal.indexOf(" "));

        var ruleIndex = parseInt(tempVal);
        var currentRuleValue = parseInt(this.model.get("voucherConfig").redemptionMessages[ruleIndex].count);
        var legal, previousValue, nextValue;

        switch (ruleIndex) {
            case 0: //first Rule
                nextValue = parseInt(this.model.get("voucherConfig").redemptionMessages[ruleIndex + 1].count);
                legal = nextValue > valueToAdd;

                if (!legal) {
                    e.prop("value", currentRuleValue);
                    $.Notify.error(i18n.t("voucher.redeemRuleWrongValue", {"valueToAdd": currentRuleValue}));
                }
                break;
            case 20: //last rule
                previousValue = parseInt(this.model.get("voucherConfig").redemptionMessages[ruleIndex - 1].count);
                legal = previousValue < valueToAdd;

                if (!legal) {
                    e.prop("value", currentRuleValue);
                    $.Notify.error(i18n.t("voucher.redeemRuleWrongValue", {"valueToAdd": currentRuleValue}));
                }
                break;
            default: //between rule (0, 20)
                if (totalRulesCount === ruleIndex + 1) {
                    previousValue = parseInt(this.model.get("voucherConfig").redemptionMessages[ruleIndex - 1].count);
                    legal = previousValue < valueToAdd;

                    if (!legal) {
                        e.prop("value", currentRuleValue);
                        $.Notify.error(i18n.t("voucher.redeemRuleWrongValue", {"valueToAdd": currentRuleValue}));
                    }
                } else {
                    previousValue = parseInt(this.model.get("voucherConfig").redemptionMessages[ruleIndex - 1].count);
                    nextValue = parseInt(this.model.get("voucherConfig").redemptionMessages[ruleIndex + 1].count);
                    legal = (previousValue < valueToAdd && valueToAdd < nextValue);

                    if (!legal) {
                        e.prop("value", currentRuleValue);
                        $.Notify.error(i18n.t("voucher.redeemRuleWrongValue", {"valueToAdd": currentRuleValue}));
                    }
                }
                break;
        }
    }

    insertAtCaret($txtArea, text) {
        if (!$txtArea) {
            return;
        }

        var scrollPos = $txtArea.scrollTop();
        var strPos = 0;
        var br = (($txtArea[0].selectionStart || $txtArea[0].selectionStart === '0') ?
            "ff" : (document.selection ? "ie" : false));
        if (br === "ie") {
            $txtArea.focus();
            var range = document.selection.createRange();
            range.moveStart('character', -$txtArea.val().length);
            strPos = range.text.length;
        } else if (br === "ff") {
            strPos = $txtArea[0].selectionStart;
        }

        var front = ($txtArea.val()).substring(0, strPos);
        var back = ($txtArea.val()).substring(strPos, $txtArea.val().length);

        $txtArea.val(front + text + back);
        strPos = strPos + text.length;
        if (br === "ie") {
            $txtArea.focus();
            var ieRange = document.selection.createRange();
            ieRange.moveStart('character', -$txtArea.val().length);
            ieRange.moveStart('character', strPos);
            ieRange.moveEnd('character', 0);
            ieRange.select();
        } else if (br === "ff") {
            $txtArea[0].selectionStart = strPos;
            $txtArea[0].selectionEnd = strPos;
            $txtArea.focus();
        }

        $txtArea.scrollTop(scrollPos);
    }
}

export default VoucherView;
